import styled from "styled-components";
import Header from "../components/header/Header";
import SchedulePlanner from "../components/bookings_manager/schedule_planner/content/SchedulePlanner";
import { useNavigate } from "react-router-dom";

//------------------------------------------------------------------------

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  overflow: hidden;
`;

//------------------------------------------------------------------------

const SchedulePlannerPage = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Header
        text={"Schedule"}
        redirectFn={() => {
          navigate("/home");
        }}
      />
      <ContentContainer>
        <SchedulePlanner />
      </ContentContainer>
    </Container>
  );
};

export default SchedulePlannerPage;
